export const config = {
    apiUrl: process.env.REACT_APP_API_URL || '',
    siteUrl: process.env.REACT_APP_SITE_URL || '',
};
